var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 14.1247L11.4166 13.458C11.5694 13.3052 11.7465 13.2288 11.9479 13.2288C12.1493 13.2288 12.3264 13.3052 12.4791 13.458C12.6319 13.6108 12.7083 13.7879 12.7083 13.9893C12.7083 14.1906 12.6319 14.3677 12.4791 14.5205L10.5208 16.4788C10.368 16.6316 10.1944 16.708 9.99998 16.708C9.80554 16.708 9.63192 16.6316 9.47915 16.4788L7.52081 14.5205C7.36803 14.3677 7.29165 14.1941 7.29165 13.9997C7.29165 13.8052 7.36803 13.6316 7.52081 13.4788C7.67359 13.3261 7.85067 13.2497 8.05206 13.2497C8.25345 13.2497 8.43054 13.3261 8.58331 13.4788L9.24998 14.1247L9.24998 3.74967C9.24998 3.54134 9.3229 3.36426 9.46873 3.21842C9.61456 3.07259 9.79165 2.99967 9.99998 2.99967C10.2083 2.99967 10.3854 3.07259 10.5312 3.21842C10.6771 3.36426 10.75 3.54134 10.75 3.74967L10.75 14.1247Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDownArrow);
export default __webpack_public_path__ + "static/media/sortDownArrow.c0e797c5e5bf56841fa11242dc8b235e.svg";
export { ForwardRef as ReactComponent };